import react from 'react'
import { Button, Tooltip } from '@mui/material'
import HistoryMessagesDialog from '../../Dialogs/HistoryMessagesDialog'
import { fetchHistoryMessages } from '../../Report/NewDetailedRegister/detailed_register_functions'
import ExportIcon from '@mui/icons-material/GetApp';
import ChatIcon from '@mui/icons-material/Chat';
import { RenderVoiceActions } from '../../Report/NewDetailedRegister/contact_graph_exception';
import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import CancelIcon from "@mui/icons-material/Cancel"
import CheckIcon from "@mui/icons-material/Check"
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const RenderAction = ({ action, data, contact, setParent, editMode }) => {

    return (
        <>
            {action === 'see' && 
                <>
                    <Tooltip title="Visualizar histórico de mensagens" placement="top" disableInteractive>
                        <Button className={data.uniqueid
                            ? 'action-button'
                            : 'action-button is-transfer'
                        }
                            onClick={async () => {
                                const dialogData = await fetchHistoryMessages(data.uniqueid)
                                if (dialogData) {
                                    if (dialogData.messages.length === 0) {
                                        useNotification(
                                            'Atenção!',
                                            'Não há mensagens para exibir.',
                                            'info'
                                        )
                                        return
                                    }
                                    setParent({
                                        activeDialog: (
                                            <HistoryMessagesDialog open={true}
                                                activeChat={dialogData}
                                                uniqueId={dialogData.uniqueid}
                                                nick={dialogData.nick}
                                                lastDateTime={dialogData.time}
                                                historyMessages={dialogData.messages}
                                                platform={dialogData.platform}
                                                accountcode={dialogData.accountcode}
                                                isReport={true}
                                                handleClose={() => setParent({ activeDialog: null })}
                                                positionFixed
                                            />
                                        )
                                    })
                                }


                            }}
                        >
                            <ChatIcon />
                        </Button>
                    </Tooltip>
                </>
            }
            {action === 'download' && !data.chatmode &&
                <>
                    <Tooltip title="Exportar histórico de mensagens" placement="top" disableInteractive>
                        <Button className="action-button"
                            href={"/api/api/enterprises/"
                                + contact.enterprise
                                + "/reports/chat/detailed/download/"
                                + data.uniqueid
                                + "/"
                                + data.time
                                + "/"
                            }
                        >
                            <ExportIcon />
                        </Button>
                    </Tooltip>
                </>
            }
            {action === 'downloadvoice' &&
                <>
                    <RenderVoiceActions row={data} />
                </>
            }
            {action === 'movescout' &&
                <>
                    <Tooltip title="Visualizar histórico de mensagens" placement="top" disableInteractive>
                        <Button className={data.uniqueid
                            ? 'action-button'
                            : 'action-button is-transfer'
                        }
                            onClick={() => {
                                const url = '/scout?account=' + data.owner + '&chat=' + data.id;
                                window.location = url;
                            }}
                        >
                            <ChatIcon />
                        </Button>
                    </Tooltip>
                </>}
            {(action === 'edit' &&
                data.editcallback) && 
                <>
                    {editMode?.id !== data.originId ?
                    <Tooltip title='Editar'>
                        <Button onClick={
                            () => data.editcallback('open')
                        } className='action-button'>
                            <EditIcon />
                        </Button>
                    </Tooltip> 
                    :
                    <Tooltip title='Salvar'>
                        <Button onClick={
                            () => data.editcallback('save')
                        } className='action-button'>
                            <CheckIcon />
                        </Button>
                    </Tooltip> }
                </>
            }
            {(action === 'delete' &&
                data.deletecallback) && 
                <>
                    {editMode?.id !== data.originId ?
                    <Tooltip title='Excluir'>
                        <Button onClick={
                            () => data.deletecallback()
                        } className='action-button delete'>
                            <DeleteIcon />
                        </Button>
                    </Tooltip> 
                    :
                    <Tooltip title='Cancelar'>
                        <Button onClick={
                            () => data.editcallback('cancel')
                        } className='action-button delete'>
                            <CancelIcon />
                        </Button>
                    </Tooltip> }
                </>
            }
            {action === 'viewopportunity' && 'viewopportunity' in data ?
                <Tooltip title='Ver oportunidade'>
                    <Button onClick={
                        () => data.viewopportunity()
                    } className='action-button'>
                        <OpenInNewIcon fontSize="small" />
                    </Button>
                </Tooltip> : null
            }
        </>
    )
}

export default RenderAction